var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconStoreColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CFD8DC",
    d: "M1.19 9.524h22.619v11.31H1.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0BEC5",
    d: "M1.19 20.834h22.619v2.38H1.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M14.286 12.5h7.143v10.714h-7.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3F2FD",
    d: "M3.571 12.5h8.333v6.548H3.571z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E88E5",
    d: "M4.167 13.096h7.143v5.357H4.167z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.94 18.155c-.178 0-.297.119-.297.297v1.19c0 .18.119.298.297.298.179 0 .298-.119.298-.297v-1.19c0-.18-.119-.298-.298-.298z",
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.571 7.738)",
    fill: "#558B2F"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.929,
    cy: 1.786,
    r: 1.786
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.071,
    cy: 1.786,
    r: 1.786
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.786,
    cy: 1.786,
    r: 1.786
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#7CB342"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.024 1.786H2.976c-.655 0-1.19.535-1.19 1.19v1.786h21.428V2.976c0-.655-.535-1.19-1.19-1.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.715 4.762h3.57v4.762h-3.57zM20.238 4.762h-2.976l.595 4.762h3.572zM4.762 4.762h2.976l-.595 4.762H3.57z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.738)",
    fill: "#FFA000"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.071,
    cy: 1.786,
    r: 1.786
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 1.786a1.754 1.754 0 01-1.786 1.785 1.754 1.754 0 01-1.785-1.785C21.429.774 22.202 0 23.214 0L25 1.786z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.929,
    cy: 1.786,
    r: 1.786
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.786C0 2.798.774 3.57 1.786 3.57A1.754 1.754 0 003.57 1.786 1.754 1.754 0 001.786 0L0 1.786z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFC107"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.262 4.762h-2.976v4.762h3.571zM23.214 4.762h-2.976l1.19 4.762H25zM7.738 4.762h2.976v4.762H7.143zM1.786 4.762h2.976l-1.19 4.762H0z"
  })))));
}

export default SvgCommonIconStoreColor;